import { useEffect, useState } from 'react';
import { formatUtcInTimezone } from '../../lib/time.js';

/**
 * Live UTC clock pill displayed in the user's timezone. Ticks every second.
 * Mirrors the pattern used elsewhere in the vendor's product line — a dark
 * always-visible chip directly above the build/copyright footer.
 */
export function SystemClock({ timezone }) {
  const [now, setNow] = useState(() => new Date().toISOString());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date().toISOString()), 1000);
    return () => clearInterval(id);
  }, []);

  // Pill geometry mirrors the active <NavLink> in the sidebar (gap-3,
  // rounded-2xl, px-3 py-2.5, text-sm font-medium) so the three sidebar
  // accents — active menu / PWA action / clock — share the same silhouette.
  return (
    <div className="flex w-full items-center gap-3 rounded-2xl bg-ink px-3 py-2.5 text-sm font-medium text-white">
      <i className="fa-regular fa-clock w-4 text-[15px] text-white/70" aria-hidden="true" />
      <span className="flex-1 text-left font-mono tabular-nums tracking-tight">
        {formatUtcInTimezone(now, timezone || 'UTC')}
      </span>
    </div>
  );
}
